import styled from 'styled-components';

export const ContainerBody = styled.div`
  padding-bottom: 20px;
`;

export const WrapperInfo = styled.div`
  padding-top: 16px;
`;

export const WrapperInfo1 = styled.div`
  padding-bottom: 16px;
`;

export const Subtext = styled.p`
  font: 16px Montserrat;
  font-weight: 400;
  color: #898b8e;
  line-height: 24px;
`;
